export const UnblockAccBlueBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="69"
    fill="none"
    viewBox="0 0 69 69"
    {...props}>
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.176"
      fill="#DEF3FF"
      rx="28"></rect>
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.176"
      stroke="#F1FAFF"
      strokeWidth="8"
      rx="28"></rect>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M34.5 46.676c6.875 0 12.5-5.625 12.5-12.5s-5.625-12.5-12.5-12.5S22 27.3 22 34.176s5.625 12.5 12.5 12.5z"></path>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M29.188 34.176l3.537 3.538 7.087-7.075"></path>
  </svg>
);
